export default __webpack_public_path__ + "static/ekopuchatek-42ba218c04990c5391ece33bc3a8d6c0.png";